module.exports = __webpack_public_path__ + "img/@logo_kftc@3x.3d9d1bb7.png";